export default __webpack_public_path__ + "static/media/issue.276c9a38.svg";